module.exports = __webpack_public_path__ + "static/media/Surrounding2.d11d23a6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding2.jpeg
// module id = 575
// module chunks = 0